var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{key:"imageGroup",staticClass:"pa-1 thin-frame elevation-1",attrs:{"outlined":""}},[_c('v-chip',{staticClass:"frame-title-chip",attrs:{"small":"","color":_vm.$vuetify.theme.dark ? 'grey darken-3' : 'white'}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{staticClass:"pa-1"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }